import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    getAllCurrencyOptions,
    getCurrentEnterpriseCurrencyOptions,
} from '@mews-commander/legacy-entities/src/ducks/currencies';
import { SelectField } from '../reduxFields';

export const AllCurrencySelectField = connect(
    createStructuredSelector({
        options: getAllCurrencyOptions,
    })
)(SelectField);

export const CurrentEnterpriseCurrencySelectField = connect(
    createStructuredSelector({
        options: getCurrentEnterpriseCurrencyOptions,
    })
)(SelectField);
